/* Razorpay's hosted links cannot send the payer back to us, so its purchases and card
   changes run in its own Checkout over our page, opened with the options billing sent. */

const SCRIPT = "https://checkout.razorpay.com/v1/checkout.js";

type RazorpayCheckout = new (options: Record<string, unknown>) => { open: () => void };
declare global {
  interface Window { Razorpay?: RazorpayCheckout }
}

let loading: Promise<RazorpayCheckout> | null = null;

function load(): Promise<RazorpayCheckout> {
  if (window.Razorpay) return Promise.resolve(window.Razorpay);
  loading ??= new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = SCRIPT;
    script.onload = () => (window.Razorpay ? resolve(window.Razorpay) : reject(new Error("Razorpay checkout did not load")));
    script.onerror = () => {
      loading = null; // a later click may try again
      reject(new Error("Razorpay checkout did not load"));
    };
    document.body.appendChild(script);
  });
  return loading;
}

/** Resolves true once the payer finishes, false when they close the checkout. */
export async function openRazorpayCheckout(options: Record<string, unknown>): Promise<boolean> {
  const Razorpay = await load();
  return new Promise((resolve) => {
    new Razorpay({
      ...options,
      name: "Definable",
      handler: () => resolve(true),
      modal: { ondismiss: () => resolve(false) },
    }).open();
    // Settings is a modal dialog: it sets `pointer-events: none` on <body>, which the
    // checkout, mounted under <body>, would inherit and be unclickable.
    document.querySelectorAll<HTMLElement>(".razorpay-container").forEach((el) => {
      el.style.pointerEvents = "auto";
    });
  });
}
